<template>
  <div class="panel-right" id="PANELRIGHT-SWF">

    <div class="title" v-if="platform != 'qt'"></div>
    <div class="title_action" v-if="platform != 'qt'">动作</div>

    <!-- 切换标签组件 tabs-panel -->
    <div class="tabs-panel">
      <div class="item" v-for="item, index in tabs_data">
        <i :class="item.icon"></i>
        <div class="name">{{item.name}}</div>
      </div>
    </div>

    <div class="panel-group">
      <div class="panel">
        <material></material>
      </div>

      <div class="panel">
        <action></action>
      </div>

      <div class="panel">
        <camera></camera>
      </div>

      <div class="panel">
        <euy-text></euy-text>
      </div>

      <div class="panel">
        <euy-audio></euy-audio>
      </div>

      <div class="panel">
          <align></align>
      </div>

      <div class="panel">
        <step></step>
      </div>

      <div class="panel">
        <action-info></action-info>
      </div>

      <div class="panel">
        <parts></parts>
      </div>
    </div>

    <psocket :attributes="attributes" :flashvars="flashvars"  v-if="platform == 'qt'"/>

  </div>
</template>

<script>

  // 动作市场组件
  import Action from '@/components/Action/Action'
  // 动作设置组件
  import ActionInfo from '@/components/ActionInfo/ActionInfo'
  // 部件组件
  import Parts from '@/components/Parts/Parts'
  // 镜头组件
  import Camera from '@/components/Camera/Camera'
  // 文字组件
  import EuyText from '@/components/Text/Text'
  // 属性组件
  import Step from '@/components/Step/Step'
  //对齐
  import Align from '@/components/Align/Align'
  // 声音组件
  import EuyAudio from '@/components/AudioPanel/AudioPanel'

  // Psocket 组件
  import Psocket from '@/components/Flash/PSocket'

  // 素材市场组件
  import Material from '@/components/Material/Material'

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  import EUY from '@/common/scripts/euy'

  export default {
    components: {
      Action,
      ActionInfo,
      Parts,
      Camera,
      EuyText: EuyText,
      Step,
      Align,
      EuyAudio: EuyAudio,
      Psocket,
      Material
    },
    data () {
      return {
        platform: this.$route.query.platform,
        tabs_data: [
          { name: '素材', icon: 'icon-material', active: false },
          { name: '动作', icon: 'icon-action', active: false },
          { name: '镜头', icon: 'icon-nav_scene', active: false },
          { name: '文字', icon: 'icon-nav_text', active: false },
          { name: '声音', icon: 'icon-nav_voice', active: false },
          { name: '样式', icon: 'icon-nav_action_type', active: false},
          { name: '属性', icon: 'icon-nav_attribute', active: false },
          { name: '设置', icon: 'icon-actioninfo', active: false },
          { name: '部件', icon: 'icon-parts', active: false }
        ],

        flashvars: {
          module: PANELRIGHT_NAME
        },
        attributes: {
          id: PANELRIGHT_NAME + '-PSOCKET',
          class: 'psocket',
        }
      }
    },
    mounted () {

      let platform = this.$route.query.platform

      this.platform = platform

      // PANELRIGHT
      // 模块初始化
      Protocol.onSocketInit(platform, PANELRIGHT_NAME, PANELRIGHT)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform, PANELRIGHT_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, PANELRIGHT_NAME, PANELRIGHT)
      // 接收消息
      Protocol.receiver(platform, PANELRIGHT_NAME)
      // 接收消息模块
      window[PANELRIGHT_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {

        if(sessionId == 6 && messageId == 5) {

          console.log('[' + PANELRIGHT_NAME + '][COMPLETE]')

        }

      }

    }
  }
</script>

<style lang="stylus" scoped>
  .panel-right
    background:#323232//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    width: 0
    padding-right: 56px
    .mask
      position: absolute
      top: 25px
      right: 0
      bottom: 0
      left: 0
      width: 280px
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 1
    .title
      background: #303030//#a6a6a6
      line-height: 25px
      text-align: center
      color: #e2e2e2//#3f3f3f
    .title_action
      width: 280px
      background: #323232//#a6a6a6
      line-height: 25px
      text-align: center
      color: #e2e2e2//#3f3f3f
      position: absolute
      top: 0
      left: 0
      z-index: -1
    .tabs-panel
      position: absolute
      right: 0
      top: 0
      bottom: 0
      width: 56px
      background:#323232//#f0f0f0
      z-index: 2
      overflow: hidden
      .item
        width: 56px
        height: 56px
        cursor: pointer
        i
          width: 56px
          height: 32px
          line-height: 32px
          display: block
          text-align: center
          font-size: 24px
          color:#fff//#545454
        .name
          text-align: center
          font-size: 12px
          -webkit-transform: scale(0.8)
          color:#e2e2e2
        &:hover
          background: #595959//#5c5c5c  
      .active
          background: #dbdbdb
          .name
           color:#000
          i
            color:#000 
          &:hover
            background:#dbdbdb
    .panel
      position: absolute
      top: 25px
      right: 0
      bottom: 0
      left: 0
      width: 280px
      z-index: 1
      overflow: hidden
</style>



// WEBPACK FOOTER //
// PanelRight.vue?09f21054